export default {
    dependencies: ['notificationservice'],
    callable(notificationservice) {
        notificationservice.resetNotificationsCountCache();
    },
};



// WEBPACK FOOTER //
// ./controllers/newnotificationscountreset.js